const purchaseWeighUp = () => import("./views/purchase_weigh_up.vue");

import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/purchase_weigh_up_tasting",
      component: purchaseWeighUp,
      name: "Purchase weigh up tasting",
      meta: {
        groupName: "QC & QA",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
